import { Box, Typography } from '@mui/material';

import GoLogo from '@/components/GoLogo';
import Loader from '@/components/Loader';
import DefaultLayout from '@/layouts/DefaultLayout';

const LoadingPage = () => {
  return (
    <DefaultLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          mt: '8%'
        }}
      >
        <GoLogo size={40} />
        <Box>
          <Loader />
          <Typography sx={{ fontSize: 36, fontWeight: 700, mb: 2 }}>Please wait...</Typography>
        </Box>
      </Box>
    </DefaultLayout>
  );
};
export default LoadingPage;
